import React, { useState } from 'react';
import T from 'prop-types';
import useEligibilityCall from 'srcAlias/client/global/customHooks/useEligibilityCall';
import useAppDataReviewCall from 'srcAlias/client/global/customHooks/useAppDataReviewCall';
import useAccountListCall from 'srcAlias/client/global/customHooks/useAccountListCall';
import hooks from 'hooksAlias';
import get from 'lodash/get';
import has from 'lodash/has';
import { Loading } from '@piggybank/core';
import { setEligibilityData } from 'srcAlias/client/state/actions/eligibilityActions';
import { setAppReviewData } from 'srcAlias/client/state/actions/applicationDataReviewActions';
import { setAccountListData } from 'srcAlias/client/state/actions/accountListActions';
import { Ineligible } from './pages/ineligible';
import { useDispatch } from 'react-redux';
import { TechnicalError } from 'srcAlias/client/segments/decision/pages/TechnicalError';
import {
  checkResponse,
  isEligibilityResponsePresent,
  isResponseDataPresent,
} from './checkResponse';
import {
  TECHNICAL_ERROR_PAGE,
  INELIGIBILE_PAGE,
  CUSTOMER_SEGMENT,
} from 'srcAlias/client/enums/eligibilitySegment';

export const Eligibility = ({ nextSegment, config }) => {
  const dispatch = useDispatch();
  const [segmentName] = config;
  const [eligibilityResponse, setEligibilityResponse] = useState(null);
  const [accountListResponse, setAccountListResponse] = useState(null);
  const [appDataReviewResponse, setAppDataReviewResponse] = useState(null);

  const hasLoadingScreenContent = has(
    hooks,
    'eligibility.loading.LoadingScreenHook'
  );

  const LoadingScreenContent = get(
    hooks,
    'eligibility.loading.LoadingScreenHook',
    () => null
  );
  useEligibilityCall(setEligibilityResponse);
  if (isEligibilityResponsePresent(eligibilityResponse)) {
    dispatch(setEligibilityData(eligibilityResponse));
  }
  useAppDataReviewCall(setAppDataReviewResponse);
  if (isResponseDataPresent(appDataReviewResponse)) {
    dispatch(setAppReviewData(appDataReviewResponse));
  }
  useAccountListCall(setAccountListResponse);
  if (isResponseDataPresent(accountListResponse)) {
    dispatch(setAccountListData(accountListResponse));
  }

  // Always call the hook, but only pass the setter if the condition is met
  const pageToRender = checkResponse(
    eligibilityResponse,
    accountListResponse,
    appDataReviewResponse
  );
  switch (pageToRender) {
    case INELIGIBILE_PAGE:
      return <Ineligible segmentName={segmentName} pageName="ineligible" />;
    case TECHNICAL_ERROR_PAGE:
      return (
        <TechnicalError segmentName={'decision'} pageName={'technicalError'} />
      );
    case CUSTOMER_SEGMENT:
      nextSegment();
    /* falls through */
    default:
      return (
        <Loading show={true}>
          {hasLoadingScreenContent && <LoadingScreenContent path={'loading'} />}
        </Loading>
      );
  }
};

Eligibility.propTypes = {
  config: T.arrayOf(T.oneOfType([T.string, T.object])),
  nextSegment: T.func.isRequired,
};

export default Eligibility;
